import get from 'lodash/get';
import { useFormState } from 'react-final-form';
import { InputPairContainer } from '../InputPairContainer';

import { PolicyCardForm } from './_components/PolicyCardForm';
import { RffCheckbox, useControlsGroupState } from '@cast/shared-rff-ui';

import { Typography, Stack, tokens } from '@cast/design-system';

type Props = {
  showGpu?: boolean;
};

export const OptimizedResourcesField = ({ showGpu }: Props) => {
  const { errors } = useFormState({ subscription: { errors: true } });

  const { namePrefix = '' } = useControlsGroupState();

  const error = get(errors, namePrefix);

  return (
    <Stack>
      <InputPairContainer
        data-testid="optimized-resources-field"
        gridTemplateColumns={showGpu ? '1fr 1fr 1fr' : '1fr 1fr'}
      >
        <PolicyCardForm
          label="CPU"
          control={<RffCheckbox name="cpu" size="small" testId="cpu" />}
        />
        <PolicyCardForm
          label="Memory"
          control={<RffCheckbox name="memory" size="small" testId="memory" />}
        />
        {showGpu && (
          <PolicyCardForm
            label="GPU"
            control={<RffCheckbox name="gpu" size="small" testId="gpu" />}
          />
        )}
      </InputPairContainer>
      {error && (
        <Typography
          mt={8}
          variant="P12R"
          color={tokens.theme.fg.status.error}
          data-testid="error"
        >
          At least one resource type needs to be checked for optimization
        </Typography>
      )}
    </Stack>
  );
};
